import React, { useState } from 'react';
import { connect } from 'react-redux';

// components
import { Element, Checkbox, Breakpoint } from '@americanexpress/aqx-components';

// selectors
import {
  isGCSMember,
  getCardMemberCards,
  getMemberCardShortNames
} from 'src/universal/redux/cardMemberInfo.js';
import {
  getSelectedCompareCards,
  dispatchAddCardToCompare,
  dispatchRemoveCardFromCompare
} from 'src/universal/redux/compareCardsTray';
import { addRemoveButtonData } from 'page_modules/business-vac/redux/index.js';
import { makeGetAddToCompareText } from 'page_modules/business-vac/components/CardTileDesktop/redux';

// utils
import { addRemoveCtaHandler } from 'page_modules/business-vac/utils/index.js';
import textRemoveTags from 'service_modules/utils/text-remove-tags';

// styles

import styles from './__styles__/index.scss?modules';

function CompareButton({
  cardTitle,
  onClickProps,
  selectedCards,
  addCardToCompare,
  removeCardFromCompare,
  shortName,
  text,
  mobile = false
}) {
  const { addToCompare } = onClickProps;

  const [ariaMessage, setAriaMessage] = useState('');

  const isCardInTray = selectedCards.includes(shortName);

  const changeAriaMessage = text => {
    const strippedHeadline = text ? textRemoveTags(text) : '';
    if (isCardInTray) {
      setAriaMessage(`${strippedHeadline} removed from Compare`);
    } else if (selectedCards.length === 2) {
      const compareButton = document.querySelector('.action-button');
      setAriaMessage(`${strippedHeadline} added to Compare. ${addToCompare.text}`);
      compareButton.focus();
    } else {
      setAriaMessage(`${strippedHeadline} added to Compare`);
    }
    setTimeout(() => setAriaMessage(''), 5000);
  };

  const onClick = () =>
    addRemoveCtaHandler(
      cardTitle,
      { ...onClickProps },
      addCardToCompare,
      removeCardFromCompare,
      true,
      changeAriaMessage,
      shortName
    );

  return (
    <Breakpoint>
      {({ sm }) => {
        const trayLength = 3;
        const styleClass = sm ? 'mobileContainer' : 'container';
        return (
          <Element className={styles[styleClass]}>
            <div aria-live="polite" className="sr-only">
              {ariaMessage}
            </div>
            <Checkbox
              disabled={selectedCards.length >= trayLength && !isCardInTray}
              checked={isCardInTray}
              qeId={`select-checkbox-${shortName}${mobile ? '-mobile' : ''}`}
              id={`select-checkbox-${shortName}${mobile ? '-mobile' : ''}`}
              onClick={onClick}
              label={text}
            />
          </Element>
        );
      }}
    </Breakpoint>
  );
}
const mapStateToProps = () => {
  const getAddToCompareText = makeGetAddToCompareText();
  return state => {
    return {
      selectedCards: getSelectedCompareCards(state),
      isGCSMember: isGCSMember(state),
      cardMemberCards: getCardMemberCards(state),
      cmCardsShortname: getMemberCardShortNames(state),
      onClickProps: addRemoveButtonData(state),
      text: getAddToCompareText(state)
    };
  };
};
const mapDispatchToProps = dispatch => ({
  addCardToCompare: shortName => dispatchAddCardToCompare(dispatch, { shortName }),
  removeCardFromCompare: shortName =>
    dispatchRemoveCardFromCompare(dispatch, { shortName })
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CompareButton);
